import styled from '@emotion/styled'
import React, { memo } from 'react'

export interface Props {
  icon?: string
  label?: string
}

export const Item = memo(function Item({ icon, label }: Props) {
  return (
    <Container>
      {icon ? <SVG src={icon} width="57" height="49" alt={label} /> : null}
      {label ? <Label>{label}</Label> : null}
    </Container>
  )
})

const Container = styled.div`
  max-width: 11.75rem;
  margin: 0 1.575rem;
  text-align: center;

  @media (max-width: 767px) {
    width: 100%;
    max-width: none;
    margin: 3.25rem 0 0;
    padding: 0 1.5rem;

    &:first-of-type {
      margin-top: 0;
    }
  }
`

const SVG = styled.img`
  width: auto;
  height: 3.5rem;
`

const Label = styled.span`
  display: block;
  margin-top: 1.5rem;
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-weight: 600;
  font-size: 0.9375rem;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 767px) {
    margin: 1.5rem auto;
    max-width: 150px;
  }
`
